export default "__VITE_ASSET__D4OjM5LP__"